"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockItemAddToFolderEvent = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class StockItemAddToFolderEvent extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.originArea = null;
        this.relatedEventIds = null;
        this.searchIdentifiers = null;
    }
    schema() {
        return StockItemAddToFolderEvent.schema;
    }
    subject() {
        return StockItemAddToFolderEvent.subject;
    }
}
exports.StockItemAddToFolderEvent = StockItemAddToFolderEvent;
StockItemAddToFolderEvent.subject = "stock-item-add-to-folder-event";
StockItemAddToFolderEvent.schema = {
    "type": "record",
    "name": "StockItemAddToFolderEvent",
    "namespace": "storyblocks.content",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "VIDEOBLOCKS",
                                "AUDIOBLOCKS",
                                "GRAPHICSTOCK",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "CONTRIBUTOR_PORTAL",
                                "TEMPLATE_EDITOR",
                                "ACCOUNT_SERVICE",
                                "BILLING_SERVICE",
                                "CONTENT_SERVICE",
                                "PAYOUT_SERVICE",
                                "TRANSLATION_SERVICE",
                                "CONTENT_RATING_APP",
                                "FEATURE_FLAG_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "AFTER_EFFECTS_PLUGIN",
                                "EXAMPLE_SERVICE",
                                "SEARCH_SERVICE",
                                "CONTENT_JOB",
                                "DATA_JOB",
                                "MISC",
                                "STORYBOARD",
                                "USER_SERVICE",
                                "SUBSCRIPTION_SERVICE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "user",
            "type": {
                "type": "record",
                "name": "User",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "visitorCookieId",
                        "type": [
                            "null",
                            "string"
                        ]
                    },
                    {
                        "name": "userId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "subscriptionId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "recurlySubscriptionId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "recurlySubscriptionUuid",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "organizationId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "bot",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Bot",
                                "fields": [
                                    {
                                        "name": "isBot",
                                        "type": "boolean"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "stockItem",
            "type": {
                "type": "record",
                "name": "ShallowStockItem",
                "namespace": "storyblocks.content.records",
                "fields": [
                    {
                        "name": "stockItemId",
                        "type": "int"
                    },
                    {
                        "name": "contentId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "title",
                        "type": "string"
                    },
                    {
                        "name": "distributionType",
                        "type": {
                            "type": "enum",
                            "name": "DistributionType",
                            "namespace": "storyblocks.content.enums",
                            "symbols": [
                                "MEMBER_LIBRARY",
                                "REV_SHARE",
                                "MARKETPLACE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "publishedDate",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "distributionTypeUpdatedDate",
                        "type": [
                            "null",
                            {
                                "type": "long",
                                "logicalType": "timestamp-millis"
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "contentType",
                        "type": {
                            "type": "enum",
                            "name": "ContentType",
                            "namespace": "storyblocks.content.enums",
                            "symbols": [
                                "ALL",
                                "LOOPS",
                                "MUSIC",
                                "SOUND_EFFECTS",
                                "ILLUSTRATIONS",
                                "PHOTOS",
                                "SNAPSHOTS",
                                "VECTORS",
                                "FOOTAGE",
                                "MOTION_BACKGROUNDS",
                                "TEMPLATES",
                                "VR_360",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "format",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "thumbnailUrl",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "originArea",
            "type": [
                "null",
                {
                    "type": "enum",
                    "name": "OriginArea",
                    "namespace": "storyblocks.content.enums",
                    "symbols": [
                        "AFTER_EFFECTS_PLUGIN",
                        "BROWSE_KEYWORDS",
                        "FOLDERS",
                        "FOLDERS_RELATED_CONTENT",
                        "MEMBER_STOCK_MEDIA_PAGE",
                        "MORE_LIKE_THIS",
                        "SAME_SHOOT",
                        "SAME_MODEL",
                        "SIMILAR_CLIPS",
                        "PLUGIN_SEARCH",
                        "PREMIERE_PRO_PLUGIN",
                        "SEARCH",
                        "SNAPSHOTS_VIDEO_THUMBNAIL",
                        "STOCK_DETAILS",
                        "STORYBOARD",
                        "OUTDATED_SCHEMA"
                    ],
                    "default": "OUTDATED_SCHEMA"
                }
            ],
            "default": null
        },
        {
            "name": "relatedEventIds",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "RelatedEventIds",
                    "namespace": "storyblocks.search.records",
                    "fields": [
                        {
                            "name": "carIdentifiers",
                            "type": [
                                "null",
                                {
                                    "type": "record",
                                    "name": "CrossAssetRecommendationIdentifiers",
                                    "fields": [
                                        {
                                            "name": "carId",
                                            "type": "string"
                                        },
                                        {
                                            "name": "carPageId",
                                            "type": "string",
                                            "default": ""
                                        }
                                    ]
                                }
                            ],
                            "default": null
                        },
                        {
                            "name": "storyboardRequestId",
                            "type": [
                                "null",
                                "string"
                            ],
                            "default": null
                        },
                        {
                            "name": "storyboardSceneRequestId",
                            "type": [
                                "null",
                                "string"
                            ],
                            "default": null
                        }
                    ]
                }
            ],
            "default": null
        },
        {
            "name": "searchIdentifiers",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "SearchIdentifiers",
                    "namespace": "storyblocks.search.records",
                    "fields": [
                        {
                            "name": "searchId",
                            "type": "string",
                            "doc": "f.k.a. SSLID"
                        },
                        {
                            "name": "searchPageId",
                            "type": "string",
                            "doc": "f.k.a. SGUID"
                        },
                        {
                            "name": "lastSearchId",
                            "type": [
                                "null",
                                "string"
                            ],
                            "doc": "Previous searchId",
                            "default": null
                        }
                    ]
                }
            ],
            "default": null
        },
        {
            "name": "userFolderId",
            "type": "int",
            "doc": "the folder to which the item is added. do not make this nullable without a really good reason!"
        }
    ]
};
//# sourceMappingURL=StockItemAddToFolderEvent.js.map